<div class="vc-modal" [class.pass-through]="isMinimized && !inPrompt">
  <ng-container *ngIf="inPrompt; else inCallTpl">
    <div class="prompt">
      <div class="call-card shadow-sm">
        <div class="heading">{{ "video-call.incoming-call" | translate }}</div>
        <div class="person">
          <div class="avatar">{{ callerInitials }}</div>
          <div class="info">
            <div class="name">
              {{
                displayPeerName
                  | doctorName: displayPeerProfessionalTitle
              }}
            </div>
            <div class="type" *ngIf="displayPeerBranchName as branch">
              {{ "profile.branch" | translate }}: {{ branch }}
            </div>
            <div class="type">{{ callTypeLabel }}</div>
          </div>
        </div>
        <div class="actions">
          <button
            class="btn btn-primary amts-bg-el23 btn-lg px-4"
            (click)="accept()"
          >
            {{ "video-call.accept" | translate }}
          </button>
          <button class="btn btn-danger btn-lg px-4" (click)="reject()">
            {{ "video-call.reject" | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #inCallTpl>
    <div class="fullscreen" *ngIf="!isMinimized">
      <div class="top-right-controls">
        <button
          class="btn btn-secondary minimize-btn"
          (click)="toggleMinimize()"
          title="Minimize"
        >
          &#x2015;
        </button>
      </div>
      <div class="top-left-caller-info" *ngIf="showInCallPeerInfo">
        <div class="name">
          {{ displayPeerName | doctorName: displayPeerProfessionalTitle }}
        </div>
        <div class="branch" *ngIf="displayPeerBranchName as branch">
          {{ "profile.branch" | translate }}: {{ branch }}
        </div>
        <div class="peer-status">
          <span
            class="status-pill"
            *ngIf="isRemoteAudioOff"
            [attr.title]="'video-call.mute' | translate"
          >
            <img src="/assets/icons/mic-off.svg" alt="" />
          </span>
          <span
            class="status-pill"
            *ngIf="isVideoCall && isRemoteVideoOff"
            [attr.title]="'video-call.camera-off' | translate"
          >
            <img src="/assets/icons/camera-off.svg" alt="" />
          </span>
        </div>
      </div>
      <div class="videos">
        <video
          #remoteVideo
          autoplay
          playsinline
          [class.hidden]="isRemoteVideoOff"
          class="remote"
        ></video>
        <video #localVideo autoplay playsinline class="local"></video>
      </div>
      <div class="controls">
        <div class="left">
          <span class="duration">{{ duration }}</span>
        </div>
        <div class="center">
          <div class="center-stack">
            <div class="permission-hint" *ngIf="permissionInfoKey as key">
              {{ key | translate }}
            </div>
            <div class="button-row">
              <button
                class="btn btn-icon btn-primary amts-bg-el23"
                (click)="toggleMute()"
                [disabled]="!canSendAudio"
                [attr.aria-disabled]="!canSendAudio"
                [attr.title]="!canSendAudio ? ('call.permission.partialAudio' | translate) : null"
              >
                <img [src]="muteIcon" alt="" />
              </button>

              <button
                *ngIf="isVideoCall"
                class="btn btn-icon btn-primary amts-bg-el23"
                (click)="toggleVideo()"
                [disabled]="!canSendVideo"
                [attr.aria-disabled]="!canSendVideo"
                [attr.title]="!canSendVideo ? ('call.permission.partialVideo' | translate) : null"
              >
                <img [src]="cameraIcon" alt="" />
              </button>

              <button
                class="btn btn-icon btn-primary amts-bg-el23 hangup-btn"
                (click)="hangup()"
              >
                <img [src]="hangupIcon" alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="minimized"
      [class.hidden]="!isMinimized"
      [ngStyle]="minimizedStyle"
      (mouseenter)="onMinHover(true)"
      (mouseleave)="onMinHover(false)"
    >
      <div
        class="resize-handle resize-top"
        (mousedown)="onResizeMouseDown($event, 'top')"
      ></div>
      <div
        class="resize-handle resize-right"
        (mousedown)="onResizeMouseDown($event, 'right')"
      ></div>
      <div
        class="resize-handle resize-bottom"
        (mousedown)="onResizeMouseDown($event, 'bottom')"
      ></div>
      <div
        class="resize-handle resize-left"
        (mousedown)="onResizeMouseDown($event, 'left')"
      ></div>
      <div
        class="resize-handle resize-top-left"
        (mousedown)="onResizeMouseDown($event, 'top-left')"
      ></div>
      <div
        class="resize-handle resize-top-right"
        (mousedown)="onResizeMouseDown($event, 'top-right')"
      ></div>
      <div
        class="resize-handle resize-bottom-left"
        (mousedown)="onResizeMouseDown($event, 'bottom-left')"
      ></div>
      <div
        class="resize-handle resize-bottom-right"
        (mousedown)="onResizeMouseDown($event, 'bottom-right')"
      ></div>

      <div
        class="min-content"
        (mousedown)="onMinMouseDown($event)"
        (touchstart)="onMinTouchStart($event)"
      >
        <video
          #minRemoteVideo
          autoplay
          playsinline
          [class.hidden]="isRemoteVideoOff"
        ></video>
        <div class="min-overlay">
          <div class="min-top">
            <span class="duration">{{ duration }}</span>
            <div class="min-status-inline">
              <span
                class="min-status-icon"
                *ngIf="isRemoteAudioOff"
                [attr.title]="'video-call.mute' | translate"
              >
                <img src="/assets/icons/mic-off.svg" alt="" />
              </span>
              <span
                class="min-status-icon"
                *ngIf="isVideoCall && isRemoteVideoOff"
                [attr.title]="'video-call.camera-off' | translate"
              >
                <img src="/assets/icons/camera-off.svg" alt="" />
              </span>
            </div>
            <button
              class="btn btn-sm btn-light btn-restore"
              (mousedown)="$event.stopPropagation()"
              (touchstart)="$event.stopPropagation()"
              (click)="toggleMinimize(); $event.stopPropagation()"
            >
              ⤢
            </button>
          </div>
          <div class="min-peer-info">
            <div class="min-peer-name">
              {{ displayPeerName | doctorName: displayPeerProfessionalTitle }}
            </div>
            <div class="min-peer-branch" *ngIf="displayPeerBranchName as branch">
              {{ "profile.branch" | translate }}: {{ branch }}
            </div>
          </div>

          <div class="min-actions" *ngIf="isMinHovered || minPlaybackBlocked">
            <button
              class="btn btn-sm btn-icon btn-primary"
              (mousedown)="$event.stopPropagation()"
              (touchstart)="$event.stopPropagation()"
              (click)="toggleMute(); $event.stopPropagation()"
              [disabled]="!canSendAudio"
              [attr.aria-disabled]="!canSendAudio"
              [attr.title]="!canSendAudio ? ('call.permission.partialAudio' | translate) : null"
            >
              <img [src]="muteIcon" alt="" />
            </button>

            <button
              *ngIf="isVideoCall"
              class="btn btn-sm btn-icon btn-primary"
              (mousedown)="$event.stopPropagation()"
              (touchstart)="$event.stopPropagation()"
              (click)="toggleVideo(); $event.stopPropagation()"
              [disabled]="!canSendVideo"
              [attr.aria-disabled]="!canSendVideo"
              [attr.title]="!canSendVideo ? ('call.permission.partialVideo' | translate) : null"
            >
              <img [src]="cameraIcon" alt="" />
            </button>

            <button
              class="btn btn-sm btn-icon btn-primary"
              (mousedown)="$event.stopPropagation()"
              (touchstart)="$event.stopPropagation()"
              (click)="hangup(); $event.stopPropagation()"
            >
              <img [src]="hangupIcon" alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
